export const featuredPortfolio = [
  {
    id: 1,
    image: "./img/WebApp.png",
    category: "DEVELOPMENT",
    title: "API de Rick y Morty",
    detail: "React js",
    description:  "Project made using the Rick and Morty API. On this page I show some filters to be able to find each character according to the filter that is made.",
    github: "https://github.com/lumerocode/project-test",
    demo: "https://project-test-houm.netlify.app/",

  },
  {
    id: 2,
    image: "./img/Movies.png",
    category: "DEVELOPMENT",
    title: "Popular Movies",
    detail: "Layouts",
    description:  "Project made with a movies API, to show the most recent movies.",
    github: "https://github.com/lumerocode/Popular-movies",
    demo: "https://popular-movie-api.netlify.app/",
  },
  {
    id: 3,
    image: "./img/Batatabit.png",
    category: "DEVELOPMENT",
    title: "Batatabit",
    detail: "Layouts",
    description:  "A landing page about cryptocurrencies and made with responsive design.",
    github: "https://github.com/lumerocode/Responsive-Proyect",
    demo: "https://batatabit-project-responsive.netlify.app/",
  },
  {
    id: 4,
    image: "./img/todoList.png",
    category: "DEVELOPMENT",
    title: "Todo List",
    detail: "React js",
    description:  "A web app that allows us to search, create, delete and update tasks to organize ourselves in our day.",
    github: "https://github.com/lumerocode/Curso-Intro-React",
    demo: "https://todo-list-first-project-react.netlify.app/",
  },
  {
    id: 5,
    image: "./img/Sapphire.png",
    category: "DEVELOPMENT",
    title: "Sapphire",
    detail: "React js",
    description:  "A web app where we can see the latest in Ntfs.",
    github: "https://github.com/lumerocode/landing-page-sapphire",
    demo: "https://landing-page-sapphire.netlify.app/",
  },
];
  
  export const cmsPortfolio = [
    {
        id: 1,
        image: "./img/Hana.png",
        category: "DEVELOPMENT",
        title: "Hana Industrias",
        detail: "CMS",
        description:  "Web App that offers a catalog of chemical inputs, textile auxiliaries and others, in addition to being committed to efficient service and constant technical advice.",
        github: "#",
        demo: "https://hanaindustrias.com/",
    },
    {
        id: 2,
        image: "./img/Asesor.png",
        category: "DEVELOPMENT",
        title: "Asesor Tributario",
        detail: "CMS",
        description:  "Web App that provides solutions in Business Advice to all types of companies of the different tax regimes.",
        github: "#",
        demo: "https://asesortributarioempresarial.com/",
    },
    {
        id: 3,
        image: "./img/Rikos.png",
        category: "DEVELOPMENT",
        title: "Pollería Rikos Chicken",
        detail: "CMS",
        description:  "Polleria Rikos Chicken web App, which allows you to order food.",
        github: "#",
        demo: "https://polleriarikos.com/",
    },
    {
      id: 4,
      image: "./img/Soldametal.png",
      category: "DEVELOPMENT",
      title: "Soldametal",
      detail: "CMS",
      description:  "E-commerce Web app that offers Retail & E-commerce formats with SOLDAMETAL, with the aim of providing supply solutions with physical and digital coverage nationwide.",
      github: "#",
      demo: "https://soldametal.com/",
  },
  {
      id: 5,
      image: "./img/Weld.png",
      category: "DEVELOPMENT",
      title: "Welddaf",
      detail: "CMS",
      description:  "E-commerce Web App that offers the market the highest technology in machines for all welding processes and CNC cutting systems for oxyfuel and plasma.",
      github: "#",
      demo: "https://welddaf.com/",
  },
  {
      id: 6,
      image: "./img/Divelia.png",
      category: "DEVELOPMENT",
      title: "Empleo Divelia",
      detail: "CMS",
      description:  "Web app to apply for a vacancy within the Divelia company.",
      github: "#",
      demo: "https://empleo.divelia.com/",
  },
  ];
  
  export const reactPortfolio = [
    {
        id: 1,
        image: "./img/WebApp.png",
        category: "DEVELOPMENT",
        title: "API de Rick y Morty",
        detail: "React js",
        description:  "Project made using the Rick and Morty API. On this page I show some filters to be able to find each character according to the filter that is made.",
        github: "https://github.com/lumerocode/project-test",
        demo: "https://project-test-houm.netlify.app/",
    
    },
    {
        id: 2,
        image: "./img/todoList.png",
        category: "DEVELOPMENT",
        title: "Todo List",
        detail: "React js",
        description:  "A web app that allows us to search, create, delete and update tasks to organize ourselves in our day.",
        github: "https://github.com/lumerocode/Curso-Intro-React",
        demo: "https://todo-list-first-project-react.netlify.app/",
    },

    {
      id: 3,
      image: "./img/Zing.png",
      category: "DEVELOPMENT",
      title: "Zing",
      detail: "React js",
      description:  "A web app that allows us to search, create, delete and update tasks to organize ourselves in our day.",
      github: "https://github.com/lumerocode/landing-page-zing",
      demo: "https://landing-page-zing.netlify.app/",
    },

    {
      id: 4,
      image: "./img/Sapphire.png",
      category: "DEVELOPMENT",
      title: "Sapphire",
      detail: "React js",
      description:  "A web app where we can see the latest in Ntfs.",
      github: "https://github.com/lumerocode/landing-page-sapphire",
      demo: "https://landing-page-sapphire.netlify.app/",
    },
  ];
  
  export const layoutPortfolio = [
    {
      id: 1,
      image: "./img/Movies.png",
      category: "DEVELOPMENT",
      title: "Popular Movies",
      detail: "Layouts",
      description:  "Project made with a movies API, to show the most recent movies.",
      github: "https://github.com/lumerocode/Popular-movies",
      demo: "https://popular-movie-api.netlify.app/",
    },
    {
      id: 2,
      image: "./img/Batatabit.png",
      category: "DEVELOPMENT",
      title: "Batatabit",
      detail: "Layouts",
      description:  "A landing page about cryptocurrencies and made with responsive design.",
      github: "https://github.com/lumerocode/Responsive-Proyect",
      demo: "https://batatabit-project-responsive.netlify.app/",
    },
    {
      id: 3,
      image: "./img/CardShoes.png",
      category: "DEVELOPMENT",
      title: "Product Card Design",
      detail: "Layouts",
      description:  "A card to choose the type of shoes you want to buy.",
      github: "https://github.com/lumerocode/Product-Card-Design",
      demo: "https://product-card-design.netlify.app/",
    },
    {
      id: 4,
      image: "./img/CardSlider.png",
      category: "DEVELOPMENT",
      title: "Product Card Slider",
      detail: "Layouts",
      description:  "A card to choose the type of laptop you want to buy.",
      github: "https://github.com/lumerocode/Product-Card-Slider",
      demo: "https://product-card-slider.netlify.app/",
    },
  ];
  
  export const webAppPortfolio = [
    
  ];
  